import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../interceptors/authentication.service';
import { UserRole } from '../models/user-role';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective {

  private currentRole: string;

  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthenticationService
  ) {
    const session = this.authService.SessionUserValue();
    this.currentRole = session?.Rol ?? '';
  }

  @Input() set appHasRole(requiredRole: UserRole | string) {
    if (this.currentRole === requiredRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
